/* eslint-disable import/extensions */
import { Feature } from '../common'
import { PAGES } from '../../constants/GLOBAL_VARIABLE'
import { LOGIN_TYPE, IAL_ERROR } from './enum'

/** @typedef {'steam'|'xbox'|'psn'|'nintendo'|'chzzk'} PlatformType */

export default class LoginSelector extends Feature {
  constructor({ mainUrl }) {
    super({ namespace: 'ial', enumKey: 'IAL.LOGIN_SELECTOR' })

    this.mainUrl = mainUrl || 'https://signin.nexon.com'

    const {
      support_platforms: supportPlatforms, // ex) KR:steam|xbox|psn&psn&nintendo (단, chzzk 제외)
      selected_platform: selectedPlatform, // steam | xbox | psn | nintendo | chzzk
      login_type: loginType = LOGIN_TYPE.POPUP, // POPUP | PGAE
      redirect_uri: redirectUri,
      state,

      response,
      code,
      error_code: errorCode = IAL_ERROR.LOGIN_SELECTOR.INIT_FAILED.code,
      error_name: errorName = IAL_ERROR.LOGIN_SELECTOR.INIT_FAILED.name,
      error_message: errorMessage = IAL_ERROR.LOGIN_SELECTOR.INIT_FAILED.message,
    } = this.queryParam

    // common
    this.supportPlatforms = supportPlatforms
    this.selectedPlatform = selectedPlatform
    this.loginType = loginType
    this.redirectUri = redirectUri
    this.state = state

    // from INSIGN-Front
    this.response = response
    this.code = code
    this.errorCode = errorCode
    this.errorName = errorName
    this.errorMessage = errorMessage

    console.debug('[LoginSelector Instance]', JSON.stringify(this), null, 2)
  }

  processLoginSelector({ headless = false }) {
    if (this.hasResponse()) {
      if (this.hasCode()) {
        return this.isPopup()
          ? this.postSuccessMessage()
          : this.redirectForSuccess()
      }
      if (this.hasError()) {
        return this.isPopup()
          ? this.postErrorMessage()
          : this.redirectForFail()
      }
    }

    this.saveReferrer()
    this.setCookie({ headless })
    this.gotoLoginSelector({ headless })

    return undefined
  }

  hasCode() {
    return this.response === 'success' && !!this.code
  }

  isPopup() {
    return !!(this.loginType === LOGIN_TYPE.POPUP)
  }

  setCookie({ headless }) {
    const cookieData = {
      login_type: this.loginType,
      redirect_uri: this.redirectUri,
      state: this.state,
    }

    if (headless) {
      cookieData.selected_platform = this.selectedPlatform
    } else {
      cookieData.support_platforms = this.supportPlatforms
    }

    this.namespaceCookie.setCookie(cookieData)
  }

  saveReferrer() {
    const redirect = this.redirectUri ? decodeURIComponent(this.redirectUri) : ''

    if (!(redirect || document.referrer)) return

    const url = new URL(redirect || document.referrer)
    const referrer = url.toString()
    this.redirectUri = referrer
  }

  redirectForSuccess() {
    const params = new URLSearchParams({
      success: true,
      selected_platform: this.selectedPlatform,
      state: this.state,
      code: this.code,
    })
    this.redirectWithParams(this.redirectUri, params)
  }

  redirectForFail() {
    const params = new URLSearchParams({
      success: false,
      selected_platform: this.selectedPlatform,
      state: this.state,
      error_code: this.errorCode,
      error_name: this.errorName,
      error_message: this.errorMessage,
    })
    this.redirectWithParams(this.redirectUri, params)
  }

  postSuccessMessage() {
    const successMessage = {
      success: true,
      selected_platform: this.selectedPlatform,
      state: this.state,
      data: {
        code: this.code,
      },
    }
    LoginSelector.postMessageToClient(successMessage)
  }

  postErrorMessage() {
    const errorMessage = {
      success: false,
      selected_platform: this.selectedPlatform,
      state: this.state,
      error: {
        code: this.errorCode,
        name: this.errorName,
        message: this.errorMessage,
      },
    }
    LoginSelector.postMessageToClient(errorMessage)
  }

  /**
   *
   * @param {Object} message
   * @param {boolean} message.success
   * @param {PlatformType} message.selected_platform
   *
   * @param {Object} [message.data]
   * @param {string} message.data.code
   *
   * @param {Object} [message.error]
   * @param {string} message.error.code
   * @param {string} message.error.name
   * @param {string} message.error.message
   */
  static postMessageToClient(message) {
    console.debug('[postMessageToClient]', message)

    if (!window.opener || window.opener.closed) {
      console.error('[postMessageToClient] Cannot find the parent window.')
      return
    }

    const MAX_RETRY = 3
    let retryCount = 0

    const sendMessageToPopup = () => {
      try {
        window.opener.postMessage(message, '*')
      } catch (error) {
        if (retryCount <= MAX_RETRY) {
          retryCount += 1
          sendMessageToPopup()
        } else {
          console.error('[postMessageToClient] Failed to send a message.')
        }
      }
    }

    sendMessageToPopup()
  }

  gotoLoginSelector({ headless }) {
    console.warn('Redirect to LoginSelector')

    if (headless) {
      console.warn('Using LoginSelector as headless mode')
      this.navigateToUrlWithoutHistory(`${this.mainUrl}/${PAGES.IAL_LOGIN_SELECTOR_HEADLESS}`)
    } else {
      this.navigateToUrlWithoutHistory(`${this.mainUrl}/${PAGES.IAL_LOGIN_SELECTOR}`)
    }
  }
}
